import { render, staticRenderFns } from "./TheIncomingCall.vue?vue&type=template&id=4c6e566e&scoped=true"
import script from "./TheIncomingCall.vue?vue&type=script&lang=js"
export * from "./TheIncomingCall.vue?vue&type=script&lang=js"
import style0 from "./TheIncomingCall.vue?vue&type=style&index=0&id=4c6e566e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6e566e",
  null
  
)

export default component.exports